import { render, staticRenderFns } from "./CanceledDepartures.vue?vue&type=template&id=241fa9c6"
import script from "./CanceledDepartures.vue?vue&type=script&lang=js"
export * from "./CanceledDepartures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports